import styled, { css, keyframes } from "styled-components";

const slideUp = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100%);
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

export const AdCounter = styled.span`
  display: flex;
  height: 25px;
  padding: 6px 6px 6px 2px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 3px;
  color: var(--primary-dark-300);
  background-color: var(--primary-dark-100);

  font-family: Rubik;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-style: normal;
  font-weight: 400;
  white-space: nowrap;

  > span {
    border-radius: 2px;
    color: var(--primary-dark-300);
    background-color: #bfc5f9;
    padding: 0 3px;
    font-weight: 500;
    font-style: normal;
  }

  ${({ $isSingle }) =>
    $isSingle &&
    css`
      color: var(--primary-blue-400);
      background-color: #ccd1f9;

      > span {
        color: var(--primary-white);
        background-color: var(--primary-blue);
      }
    `}
`;

export const CounterContainer = styled.span`
  position: relative;
  display: inline-block;
  overflow: hidden;
  border-radius: 2px;
  color: var(--primary-dark-300);
  background-color: #bfc5f9;
  padding: 0 3px;
  font-weight: 500;
  font-style: normal;
  min-width: 1.2em;
  text-align: center;

  ${({ $isSingle }) =>
    $isSingle &&
    css`
      color: var(--primary-white);
      background-color: var(--primary-blue);
    `}
`;

export const CounterNumber = styled.span`
  display: inline-block;
  animation: ${({ $isAnimating, $direction }) =>
    $isAnimating
      ? $direction === "out"
        ? css`
            ${slideUp} 0.15s ease-in-out forwards
          `
        : css`
            ${slideIn} 0.15s ease-in-out forwards
          `
      : "none"};
`;
